import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../helpers/api_helper';
import { MatchingBonusState, MatchingBonusType } from './types';
import { toast } from 'react-toastify';
import { handleValidDate, handleValidTime } from '../../../helpers/helpers';

export const getMatchingBonus = createAsyncThunk(
  'getMatchingBonus/fetch',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get(`/bonus/matching`, {
      params
    });
    return response.data.data;
  }
);

export const exportMatchingBonus = createAsyncThunk(
  'getTeamBonus/exportMatchingBonus',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get('/bonus/matching/export', {
      params
    });

    try {
      if (response?.data?.data?.userMatchingBonuses) {
        const dataForExport = response?.data?.data?.userMatchingBonuses.map(
          (u: any) => {
            return {
              id: u?.id,
              userId: u?.userId,
              userTeamBonusId: u?.userTeamBonusId,
              userPackageId: u?.userPackage?.id,
              amount: u?.amount,
              comissionAmount: u?.comissionAmount,
              comissionLevels: u?.comissionLevels,
              comissionPercent: u?.comissionPercent,
              status: statusForTable(u?.status),
              dateCreated: u?.dateCreated
                ? `${handleValidDate(u.dateCreated)}, ${handleValidTime(
                    u.dateCreated
                  )}`
                : ''
            };
          }
        );

        return dataForExport;
      }

      if (response.data.message) {
        toast.success(response.data.message);
      }
    } catch (error: any) {
      toast.error(error.response.data.error);
    }
  }
);

export const statusForTable = (status: number) => {
  switch (status) {
    case 1:
      return 'PENDING';
    case 2:
      return 'PAID';
    case 3:
      return 'INELIGIBLE';

    default:
      break;
  }
};

export const paramsForExport = (searchParams: URLSearchParams) => {
  const params = searchParams;
  params.delete('countPerPage');
  params.delete('numberOfPage');
  params.delete('sortBy');
  params.delete('sortOrder');
  return params;
};

export const exportHeaders = [
  { label: 'Bonus ID', key: 'id' },
  { label: 'User ID', key: 'userId' },
  { label: 'Order ID', key: 'userPackageId' },
  { label: 'Team Bonus ID', key: 'userTeamBonusId' },
  { label: 'TB Amount', key: 'amount' },
  { label: 'Amount', key: 'comissionAmount' },
  { label: 'LVL', key: 'comissionLevels' },
  { label: '%', key: 'comissionPercent' },
  { label: 'Date Created', key: 'dateCreated' },
  { label: 'Status', key: 'status' }
];

const initialState = {
  data: {},
  loading: false,
  dataForExport: [],
  loadingExport: false,
  totalCount: 0
} as MatchingBonusState;

const getMatchingBonusSlice = createSlice({
  name: 'getMatchingBonus',
  initialState,
  reducers: {
    removeMatchingBonusForExport(state) {
      state.dataForExport = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getMatchingBonus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMatchingBonus.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload;
      state.totalCount = payload.count;
    });
    builder.addCase(getMatchingBonus.rejected, (state) => {
      state.loading = false;
    });

    //loading export
    builder.addCase(exportMatchingBonus.pending, (state) => {
      state.loadingExport = true;
    });
    builder.addCase(exportMatchingBonus.fulfilled, (state, { payload }) => {
      state.loadingExport = false;
      state.dataForExport = payload;
    });
    builder.addCase(exportMatchingBonus.rejected, (state) => {
      state.loadingExport = false;
    });
  }
});

export const { removeMatchingBonusForExport } = getMatchingBonusSlice.actions;

export default getMatchingBonusSlice.reducer;
